/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_WedInputs */

const en_ui_day_wed = /** @type {(inputs: Ui_Day_WedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wed`)
};

const de_ui_day_wed = /** @type {(inputs: Ui_Day_WedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi`)
};

/**
* | output |
* | --- |
* | "Wed" |
*
* @param {Ui_Day_WedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_wed = /** @type {((inputs?: Ui_Day_WedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_WedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_wed(inputs)
	return de_ui_day_wed(inputs)
});